var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('script',{attrs:{"async":"","src":"https://www.googletagmanager.com/gtag/js?id=G-16KQZCXLFL"}}),_vm._v(" "),_c('script',[_vm._v("\n    window.dataLayer = window.dataLayer || [];\n    function gtag(){dataLayer.push(arguments);}\n    gtag('js', new Date());\n\n    gtag('config', 'G-16KQZCXLFL');\n  ")])])
}]

export { render, staticRenderFns }